// <s-sticky-buy> — mobile sticky add-to-bag bar.
// Shows the bar (data-visible) only while the element matched by [data-target] (the real buy area) sits above the
// viewport, i.e. the shopper has scrolled past it. The bar's button submits the real product form via the form
// attribute, so this element never adds to the bag itself. Each time the bar shows it mirrors the inline form's
// price and availability, so variant changes (which re-render the inline partials) stay in sync.
// Without JS the bar stays hidden (see config/styles.css).
class StickyBuy extends HTMLElement {
  #observer = null;

  connectedCallback() {
    const target = document.querySelector(this.dataset.target || '[data-product-form]');
    if (!target) return;
    this.#observer = new IntersectionObserver(([entry]) => {
      const passed = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
      if (passed) this.#sync(target);
      this.toggleAttribute('data-visible', passed);
      this.inert = !passed;
    });
    this.inert = true;
    this.#observer.observe(target);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }

  #sync(target) {
    const price = document.querySelector('[data-product-price]');
    const stickyPrice = this.querySelector('[data-sticky-price]');
    // The price block's first <bdi> is always the current (or sale) amount; the compare-at price comes later.
    const priceText = price?.querySelector('bdi')?.textContent?.trim();
    if (stickyPrice && priceText) stickyPrice.textContent = priceText;

    // Mirror the current H1 (it names the selected shade on the foundation page).
    const titleText = document.querySelector('.albra-pdp-title')?.textContent?.trim();
    const stickyTitle = this.querySelector('[data-sticky-title]');
    if (stickyTitle && titleText) stickyTitle.textContent = titleText;

    const available = Boolean(target.querySelector('button[name="add"]'));
    this.querySelector('[data-sticky-add]')?.toggleAttribute('hidden', !available);
    this.querySelector('[data-sticky-sold-out]')?.toggleAttribute('hidden', available);
  }
}

if (!customElements.get('s-sticky-buy')) customElements.define('s-sticky-buy', StickyBuy);
